<div class="main_body">
  <app-page-header
    title="セクショングループ管理者"
    i18n-title="@@adminSectionGroup.adminList.title.adminList"
    subtitle="セクショングループ管理者の情報の閲覧・編集・停止・再開の設定を行います。セクショングループの管理者はグループに属するセクションの一覧、作成や月次のデータ使用量などを確認することができます。"
    i18n-subtitle="@@adminSectionGroup.adminList.description.adminManagement"
    icon="admin"
  />
  <div class="contents">
    <div class="contents_section_group">
      <section class="contents__section">
        <div class="table-toolbar">
          <!-- M3 Expandable Search Pill -->
          <div
            class="search-pill"
            [class.expanded]="searchExpanded()"
            [class.has-value]="filter.trim()"
            (click)="expandSearch()"
            role="search"
          >
            <mat-icon class="search-pill__icon">search</mat-icon>
            @if (!searchExpanded() && !filter.trim()) {
              <span class="search-pill__placeholder" i18n="@@adminSectionGroup.adminList.placeholder.adminFilter">管理者 氏名 フィルター</span>
            }
            <input
              #searchInput
              type="text"
              class="search-pill__input"
              [value]="filter"
              (input)="applyFilter($event)"
              (blur)="onSearchBlur()"
              [attr.aria-label]="'管理者 氏名 フィルター'"
              i18n-aria-label="@@adminSectionGroup.adminList.search.ariaLabel"
            />
            @if (filter.trim()) {
              <button
                type="button"
                class="search-pill__clear"
                (click)="clearSearch($event)"
                aria-label="検索をクリア"
                i18n-aria-label="@@adminSectionGroup.adminList.search.clearAriaLabel"
              >
                <mat-icon>close</mat-icon>
              </button>
            }
          </div>
          <!-- Action buttons - right aligned -->
          <div class="table-toolbar__actions">
            @if (hasSectionGroupAdminManagement || hasAllSectionGroupManagement) {
              <button mat-stroked-button
                      class="list-action-button"
                      (click)="createAdmin()">
                <span i18n="@@adminSectionGroup.adminList.button.createAdmin">管理者作成</span>
                <mat-icon>person_add</mat-icon>
              </button>
              <button mat-stroked-button
                      class="list-action-button"
                      (click)="inviteAdmin()">
                <span i18n="@@adminSectionGroup.adminList.button.inviteAdmin">管理者招待</span>
                <mat-icon>mail</mat-icon>
              </button>
            }
            <button
              mat-icon-button
              class="table-toolbar__btn"
              (click)="refreshData()"
              matTooltip="更新"
              aria-label="更新"
              i18n-matTooltip="@@adminSectionGroup.adminList.tooltip.refresh"
              i18n-aria-label="@@adminSectionGroup.adminList.ariaLabel.refresh"
            >
              <mat-icon>refresh</mat-icon>
            </button>
          </div>
        </div>

        <div class="user-list-container mat-elevation-z0">
          @if (isLoading()) {
            <app-table-skeleton [rows]="5" />
          } @else {
          <table class="entry-table staff" mat-table [dataSource]="dataSource" matSort matSortActive="status" matSortDirection="desc">

            <ng-container matColumnDef="name" sticky>
              <th mat-header-cell *matHeaderCellDef mat-sort-header class="sticky-left-column" i18n="@@adminSectionGroup.adminList.table.name"> 氏名 </th>
              <td mat-cell *matCellDef="let row" class="sticky-left-column">
                @if (row.userId == loginUserId) {
                  {{row.name}}<span class="status-badge status-badge--active">You</span>
                } @else {
                  <span>{{row.name}}</span>
                }
              </td>
            </ng-container>

            <ng-container matColumnDef="status">
              <th mat-header-cell *matHeaderCellDef mat-sort-header style="min-width: 90px;" i18n="@@adminSectionGroup.adminList.table.status"> ステータス </th>
              <td mat-cell *matCellDef="let row">
                @if (row.status == 'OPEN') {
                  <span class="status-badge status-badge--active">{{accountStatus[row.status]}}</span>
                } @else {
                  <span class="status-badge status-badge--inactive">{{accountStatus[row.status]}}</span>
                }
              </td>
            </ng-container>

            <ng-container matColumnDef="assignedDate" stickyEnd>
              <th mat-header-cell *matHeaderCellDef mat-sort-header class="sticky-end-column" i18n="@@adminSectionGroup.adminList.table.assignedDate"> 管理開始日 </th>
              <td mat-cell *matCellDef="let row" class="sticky-end-column table-cell-date"> {{row.assignedDate}} </td>
            </ng-container>

            <!-- Actions Column (hover reveal) -->
            <ng-container matColumnDef="stop" stickyEnd>
              <th mat-header-cell *matHeaderCellDef class="actions-header"></th>
              <td mat-cell *matCellDef="let row" class="actions-cell">
                <div class="staff-actions-group">
                  @if (row.status === 'OPEN') {
                    <button
                      mat-icon-button
                      class="staff-action-button staff-action-button--danger"
                      (click)="openStaffActivationDialog(row.id)"
                      matTooltip="アカウント停止"
                      i18n-matTooltip="@@adminSectionGroup.adminList.tooltip.deactivate"
                      aria-label="アカウント停止"
                      i18n-aria-label="@@adminSectionGroup.adminList.ariaLabel.deactivate"
                    >
                      <mat-icon class="staff-action-icon">person_off</mat-icon>
                    </button>
                  }
                  @if (row.status === 'CLOSE') {
                    <button
                      mat-icon-button
                      class="staff-action-button staff-action-button--success"
                      (click)="openStaffActivationDialog(row.id)"
                      matTooltip="アカウント再開"
                      i18n-matTooltip="@@adminSectionGroup.adminList.tooltip.activate"
                      aria-label="アカウント再開"
                      i18n-aria-label="@@adminSectionGroup.adminList.ariaLabel.activate"
                    >
                      <mat-icon class="staff-action-icon">how_to_reg</mat-icon>
                    </button>
                  }
                </div>
              </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;"
              [class.row-self]="loginUserId === row.id"
              [class.row-closed]="row.status === 'CLOSE'"
              (click)="openAdminDetailsDialog(row)">
            </tr>
          </table>
          }
        </div>
        <mat-paginator class="user-list-paginator" [pageSize]="50" [pageSizeOptions]="[5, 10, 25, 50, 100]"></mat-paginator>
      </section>
    </div>
    <!--/contents_section_group-->
  </div>
  <!--/contents-->
</div>
